import MasonryGallery from "@/components/MasonryGallery";
import CTASection from "@/components/CTASection";

const PortfolioPage = () => {
  return (
    <>
      <section className="pt-40 md:pt-48 pb-8 bg-white">
        <div className="container-x text-center max-w-3xl mx-auto">
          <p className="eyebrow mb-4">Portfolio</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.05]">
            Elke foto is een <span className="italic text-gold">hoofdstuk.</span>
          </h1>
          <p className="mt-6 text-neutral-600 leading-relaxed">
            Blader door een selectie van huwelijk, gezin, newborn, huisdieren en events.
            Klik op een foto om deze groot te bekijken.
          </p>
        </div>
      </section>
      <MasonryGallery />
      <CTASection />
    </>
  );
};

export default PortfolioPage;
